import { Component, inject, OnInit } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { ProfileService } from '../../core/services/profile.service';
import { NgFor, NgIf } from '@angular/common';

@Component({
  selector: 'app-menu',
  standalone: true,
  imports: [RouterLink, RouterLinkActive, NgFor, NgIf],
  templateUrl: './menu.component.html',
  styleUrl: './menu.component.scss'
})
export class MenuComponent implements OnInit {

  private profileSv = inject(ProfileService);
  menu: any[] = [];

  ngOnInit(): void {
    this.getAvailableApps();
  }

  getAvailableApps() {
    this.profileSv.getAvailableApps().subscribe((res:any) => {
      const { data } = res;
      data.result.forEach((element: any) => {
        const { ssoEntities } = element;
        this.menu.push({ 'link': ssoEntities.idpLoginUrl, 'label': element.name })
      });
    });
  }  


}
